(() => {
  if (window.__aluneaCartNoticeLoaded) return;
  window.__aluneaCartNoticeLoaded = true;

  let noticeTimer;

  /* Säker closest som klarar SVG och textnoder */
  function up(node, selector) {
    let el = node;
    while (el && el.nodeType !== 1) el = el.parentNode;
    while (el && el.nodeType === 1) {
      if (typeof el.matches === 'function' && el.matches(selector)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function showCartNotice() {
    let notice = document.getElementById('alunea-cart-notice');

    if (!notice) {
      notice = document.createElement('div');
      notice.id = 'alunea-cart-notice';
      notice.setAttribute('role', 'status');
      notice.setAttribute('aria-live', 'polite');

      notice.innerHTML = `
        <div class="alunea-cart-notice__inner">
          <div class="alunea-cart-notice__check">✓</div>
          <div class="alunea-cart-notice__text">
            <strong>Tillagd i varukorgen</strong>
            <span>Din produkt har lagts till.</span>
          </div>
          <button type="button" class="alunea-cart-notice__button" data-alunea-open-cart>
            Öppna varukorgen
          </button>
          <button type="button" class="alunea-cart-notice__close"
                  aria-label="Stäng" data-alunea-close-cart-notice>×</button>
        </div>
      `;

      document.body.appendChild(notice);
    }

    clearTimeout(noticeTimer);
    requestAnimationFrame(() => notice.classList.add('is-visible'));
    noticeTimer = setTimeout(() => notice.classList.remove('is-visible'), 5000);
  }

  function hideCartNotice() {
    const notice = document.getElementById('alunea-cart-notice');
    if (notice) notice.classList.remove('is-visible');
    clearTimeout(noticeTimer);
  }

  function drawerAvailable() {
    return !!(
      window.Shopify?.actions?.openCart ||
      document.querySelector('theme-drawer#cart-drawer') ||
      document.querySelector('[aria-controls="cart-drawer"]')
    );
  }

  function openCart() {
    const actions = window.Shopify?.actions;
    if (actions?.openCart) { actions.openCart(); return; }

    const opener = document.querySelector('[aria-controls="cart-drawer"]');
    if (opener) { opener.click(); return; }

    window.location.href = window.Theme?.routes?.cart_url || '/cart';
  }

  function isCartPageLink(node) {
    const a = up(node, 'a[href]');
    if (!a) return false;
    try {
      const url = new URL(a.getAttribute('href'), window.location.origin);
      if (url.origin !== window.location.origin) return false;
      return url.pathname.replace(/\/+$/, '').endsWith('/cart');
    } catch {
      return false;
    }
  }

  /* Fångar cart-adds utan att ändra anropen */
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);
    try {
      const requestUrl =
        typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
      if (requestUrl.includes('/cart/add') && response.ok) {
        setTimeout(showCartNotice, 150);
      }
    } catch (error) {
      console.warn('Alunea cart notice:', error);
    }
    return response;
  };

  /* CAPTURE-fasen — körs före länkens egen hantering */
  document.addEventListener('click', (event) => {
    try {
      if (up(event.target, '[data-alunea-close-cart-notice]')) {
        hideCartNotice();
        return;
      }

      const explicit = up(event.target, '[data-alunea-open-cart]');

      if ((explicit || isCartPageLink(event.target)) && drawerAvailable()) {
        event.preventDefault();
        event.stopPropagation();
        openCart();
        hideCartNotice();
      }
    } catch (error) {
      console.warn('Alunea cart notice:', error);
    }
  }, true);
})();
